// extracted by mini-css-extract-plugin
export default {"active":"ChipGroupTitle_active--WD0","inactive":"ChipGroupTitle_inactive--J54"};